const transceiverInput = document.querySelector('input[name="transceiver"]');
const transceiverInformation = document.querySelector('input[name="extraTransceiverInformation"]');

transceiverInput?.addEventListener("change", () => {
    transceiverInformation.disabled = !transceiverInput.checked;
});

if (!transceiverInformation == null) {
    transceiverInformation.disabled = !transceiverInput.checked;
}
